// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__dZVIA","text":"style_text__kU6lC","product_badge":"style_product_badge__c3Ihg","dinamic_btn_bage":"style_dinamic_btn_bage__1IGgy"};